/* eslint-disable react-refresh/only-export-components */
import { Loading } from '@linktivity/link-ui';
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  useRouteError
} from 'react-router-dom';

const Invoice = lazy(() => import('@kurotetsu/public/views/Invoice'));
const Rebate = lazy(() => import('@kurotetsu/public/views/Rebate'));
const Receipt = lazy(() => import('@kurotetsu/public/views/Receipt'));
const Voucher = lazy(() => import('@kurotetsu/public/views/Voucher'));
const CancellationPolicy = lazy(
  () => import('@kurotetsu/public/views/CancellationPolicy')
);
const NotFound = lazy(() => import('@kurotetsu/public/views/NotFound'));

function RootErrorBoundary() {
  const error = useRouteError() as Error | undefined;
  if (error?.message?.includes('Failed to fetch dynamically imported module')) {
    location.reload();
    return null;
  }
  console.error('[PublicRootErrorBoundary]', error);
  return null;
}

const lazyView = (view: JSX.Element) => {
  return (
    <Suspense
      fallback={
        <div className="loading">
          <Loading />
        </div>
      }
    >
      {view}
    </Suspense>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      {/* 運賃請求書、レストラン請求書 */}
      <Route
        path="/invoice/:businessType/:groupBookingNo/:token/:paymentId"
        element={lazyView(<Invoice />)}
      />
      {/* リベート支払明細書 */}
      <Route
        path="/rebate/:businessType/:groupBookingNo/:token/:paymentId"
        element={lazyView(<Rebate />)}
      />
      {/* 運賃、レストラン領収書 */}
      <Route
        path="/receipt/:businessType/:groupBookingNo/:token/:paymentId"
        element={lazyView(<Receipt />)}
      />
      {/* 席番表 */}
      <Route
        path="/voucher/:groupBookingNo/:token"
        element={lazyView(<Voucher />)}
      />
      <Route
        path="/cancellation-policy"
        element={lazyView(<CancellationPolicy />)}
      />
      <Route path="/404" element={lazyView(<NotFound />)} />
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
